export default "__VITE_ASSET__BOCKSJik__"